<template>
	<div class="text-white small text-center robotofonts w-100 container-fluid p-0 py-4">
		<div class="py-2 d-flex justify-content-center cprtext">Featured On</div>
		<div class="marquee-container">
			<div class="marquee-track" ref="track">
				<div class="badge"><a href="https://twelve.tools" target="_blank"><img src="https://twelve.tools/badge3-dark.svg" alt="Featured on Twelve Tools"></a></div>
				<div class="badge"><a href="https://wired.business" target="_blank"><img src="https://wired.business/badge2-dark.svg" alt="Featured on Wired Business"></a></div>
				<div class="badge"><a href="https://askaiforit.com/" target="_blank"><img src="https://askaiforit.com/badges/badge-3.svg" alt="Listed on Ask AI For IT"></a></div>
				<div class="badge"><a href="https://startupfa.me/s/techtitans?utm_source=techtitans.cloud" target="_blank"><img src="https://startupfa.me/badges/featured/dark.webp" alt="Techtitans Hub - Featured on Startup Fame" /></a></div>
				<div class="badge">
					<a href="https://projecthunt.me" target="_blank">
						<svg xmlns="http://www.w3.org/2000/svg" class="ph-badge" viewBox="0 0 180 48" role="img" aria-label="Featured on: projecthunt.me">
							<title>Featured on projecthunt.me</title>
							<rect x="0" y="0" width="100%" height="100%" rx="4" fill="#000" stroke="#E85C0D" stroke-width="1.5" />
							<g transform="translate(10, 8)">
								<image href="https://projecthunt.me/favicon.ico" width="32" height="32" />
							</g>
							<g fill="#666666" text-anchor="start" font-family="Verdana, Geneva, DejaVu Sans, sans-serif">
								<text x="50" y="20" font-size="13" font-weight="500">Featured on</text>
								<text x="50" y="36" font-size="14" font-weight="600" fill="#E85C0D">projecthunt.me</text>
							</g>
						</svg>
					</a>
				</div>
				<div class="badge"><a href="https://startuptrusted.com?ref=techtitans.cloud" target="_blank" rel="noopener"><img src="https://startuptrusted.com/api/badge?type=featured&style=dark" alt="TechTitans on StartupTrusted" /></a></div>
				<div class="badge"><a href="https://fazier.com" target="_blank"><img src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&theme=dark" alt="Fazier badge" /></a></div>
				<div class="badge"><a href="https://drchecker.net/item/techtitans.cloud" target="_blank" rel="noopener noreferrer"><img src="https://drchecker.net/api/badge?domain=techtitans.cloud" alt="Monitor your Domain Rating with DRChecker "/></a></div>
				<div class="badge"><a href="https://auraplusplus.com/projects/techtitans-cloud" target="_blank" rel="noopener"><img src="https://auraplusplus.com/images/badges/featured-on-dark.svg" alt="Featured on Aura++" /></a></div>
				<div class="badge"><a href="https://similarlabs.com/?ref=embed" target="_blank" style="cursor: pointer;"><img src="https://similarlabs.com/similarlabs-embed-badge-dark.svg" alt="SimilarLabs Embed Badge" /></a></div>
				<div class="badge"><a href="https://saaspa.ge/product/cmiwwdp8g000zjr04c4p4g7xc" target="_blank" rel="nofollow"><img src="https://saaspa.ge/api/embed/product/cmiwwdp8g000zjr04c4p4g7xc/badge.png?theme=black" alt="Featured on Saaspa.ge" /></a></div>
				<div class="badge"><a target="_blank" href="https://stackdirectory.com"><img src="https://stackdirectory.com/assets/images/badge-dark.png" alt="Stack Directory"></a></div>
				<div class="badge"><a href="https://www.verifiedtools.info" target="_blank" rel="noopener noreferrer"><img src="https://www.verifiedtools.info/badge.png" alt="Verified on Verified Tools"/></a></div>
				<div class="badge"><a href="https://turbo0.com/item/techtitanscloud" target="_blank" rel="noopener noreferrer"><img src="https://img.turbo0.com/badge-listed-dark.svg" alt="Listed on Turbo0"/></a></div>
				<div class="badge"><a href="https://findly.tools/techtitans-cloud?utm_source=techtitans-cloud" target="_blank"><img src="https://findly.tools/badges/findly-tools-badge-dark.svg" alt="Featured on findly.tools" /></a></div>
				<div class="badge"><a href="https://shipybara.com/projects/techtitans-cloud" target="_blank" rel="noopener"><img src="https://shipybara.com/images/badges/shipybara-badge-dark.svg" alt="Featured on Shipybara"/></a></div>
				<div class="badge"><a href="https://www.startupinspire.com" target="_blank"><img src="https://www.startupinspire.com/images/badge_2.svg" alt="Featured on Startup Inspire"></a></div>
				<div class="badge"><a href="https://launchigniter.com/product/techtitans-creative-technology-hub?ref=badge-techtitans-creative-technology-hub" target="_blank"><img src="https://launchigniter.com/api/badge/techtitans-creative-technology-hub?theme=dark" alt="Featured on LaunchIgniter"/></a></div>
				<div class="badge"><a href="https://www.producthunt.com/products/techtitans-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-techtitans&#0045;2" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=979905&theme=dark&t=1765307950530" alt="TechTitans - Gamified&#0032;Learning&#0032;for&#0032;Future&#0032;Creators&#0046; | Product Hunt" /></a></div>
				<div class="badge"><a href='https://www.saashub.com/techtitans-cloud?utm_source=badge&utm_campaign=badge&utm_content=techtitans-cloud&badge_variant=color&badge_kind=approved' target='_blank'><img src="https://cdn-b.saashub.com/img/badges/approved-color.png?v=1" alt="TechTitans.cloud badge"/></a></div>
				<div class="badge"><a href="https://startupeurope.net/" target="_blank"><img src="https://startupeurope.net/images/badge/badge.png" alt="Startup Europe Badge" title="Startup Europe Badge"/></a></div>
				<div class="badge"><a href="https://submitmysaas.com" target="_blank" rel="noopener noreferrer"><img src="https://submitmysaas.com/featured-badge.png" alt="Featured on SubmitMySaas"/></a></div>
				<div class="badge"><a href="https://whatlaunched.today" target="_blank" rel="noopener noreferrer" aria-label="Live on What Launched Today badge" style="display:inline-flex;align-items:center;gap:12px;padding:12px 20px;border-radius:9999px;border:1px solid #3F3A36;background:#1C1917;font-family:'Inter',Arial,sans-serif;text-decoration:none;"><span style="display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:9999px;background:#292524;border:1px solid #44403C;"><img src="https://whatlaunched.today/Logo.png" alt="What Launched Today" style="width:22px;height:22px;" /></span><span style="display:flex;flex-direction:column;line-height:1.2;"><span style="font-size:11px;letter-spacing:2px;text-transform:uppercase;color:#FDBA74;">LIVE ON</span><span style="font-size:15px;font-weight:600;color:#F3F1EF;">What Launched Today</span></span><span style="font-size:18px;color:#FDBA74;">★</span></a></div>
				<div class="badge"><a href="https://saashunt.best" target="_blank" title="Featured on SaasHunt"><img src="https://saashunt.best/images/badges/featured-on-dark.svg" alt="Featured on SaasHunt" /></a></div>
				<div class="badge"><a href="https://tinylaunch.com" target="_blank" rel="noopener"><img src="https://tinylaunch.com/tinylaunch_badge_live_now.svg" alt="TinyLaunch Badge" /></a></div>
				<div class="badge"><a href="https://peerpush.net/p/tech-titans-creative-technology-hub" target="_blank" rel="noopener"><img src="https://peerpush.net/p/tech-titans-creative-technology-hub/badge.png" alt="Tech-titans Creative Technology Hub badge"/></a></div>
				<div class="badge"><a href="https://startupslab.site" target="_blank" rel="noopener"><img src="https://cdn.startupslab.site/site-images/badge-dark.png" alt="Featured on Startups Lab"/></a></div>
				<div class="badge"><a href="https://launch-list.org/product/techtitanscloud" target="_blank"><img src="https://launch-list.org/badges/svg/launch_list_badge_live.svg" alt="Launch List Badge" /></a></div>
				<div class="badge"><a target="_blank" href="https://shinylaunch.com"><img src="https://shinylaunch.com/static/images/badge-dark.png" alt="ShinyLaunch"/></a></div>
				<div class="badge"><a href="https://devhub.best" target="_blank" title="Featured on DevHub"><img src="https://devhub.best/images/badges/featured-on-dark.svg" alt="Featured on DevHub"/></a></div>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';

const track = ref < HTMLElement | null > (null);

onMounted(() => {
	const el = track.value;
	if (!el) return;

	// κλωνοποιεί το περιεχόμενο για seamless loop
	el.innerHTML += el.innerHTML;
});
</script>
<style scoped lang="scss">
.cprtext {
	font-size: 14px;
	font-weight: 400;
	line-height: 14.06px;
}

.marquee-container {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.marquee-track {
	display: flex;
	width: max-content;
	animation: scroll 120s linear infinite;
}

.badge {
	flex: 0 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1px 40px;

	@media (max-width: 1500px) {
		padding: 1px 30px;
	}

	@media (max-width: 768px) {
		padding: 1px 20px;
	}
}

.badge a,
.badge img,
.badge svg {
	height: 36px;
	display: block;
}

@keyframes scroll {
	0% {
		transform: translateX(0);
	}

	100% {
		transform: translateX(-50%);
	}
}
</style>